<ion-button
  fill="outline"
  size="small"
  (click)="showUploadDocumentModal()"
>
  <ion-icon
    src="../assets/material-symbols/upload_file_24dp_FILL0_wght400_GRAD0_opsz24.svg"
    slot="start"
  ></ion-icon>
  {{ 'general.send_document' | translate }}
</ion-button>
